<template>
  <div class="white text-center centrarBody" style="margin-bottom:0px;">
    <v-form ref="form" @submit="submit" method="POST" id="card-form" v-model="valid">
      <v-row>
        <v-col cols="12">
          <span class="headline font-weight-black">Pago con tarjeta de Débito</span>
        </v-col>
        <v-col cols="12" class="mb-0 mt-0">
          <!-- var: datosPagoTarjeta - method: pagarConTarjeta en home esta la validacion de si descuento es mayor que saldototal-->
          <v-radio-group row v-model="cantidadPago" :rules="[rules.required]">
            <template v-slot:label>
              <div>*Seleccione la cantidad a pagar:</div>
            </template>
            <v-radio :value="`${datosPagoTarjeta.pagoVencido}`">
              <template v-slot:label>
                <div>
                  Saldo vencido:
                  <strong
                    class="success--text"
                  >{{datosPagoTarjeta.pagoVencido| currency}}</strong>
                </div>
              </template>
            </v-radio>
            <v-radio :value="`${datosPagoTarjeta.pagoDescuento}`">
              <template v-slot:label>
                <div>
                  Descuento Periódico:
                  <strong
                    class="success--text"
                  >{{datosPagoTarjeta.pagoDescuento| currency}}</strong>
                </div>
              </template>
            </v-radio>
            <v-radio :value="`${datosPagoTarjeta.pagoSaldo}`">
              <template v-slot:label>
                <div>
                  Saldo total:
                  <strong class="success--text">{{datosPagoTarjeta.pagoSaldo| currency}}</strong>
                </div>
              </template>
            </v-radio>
            <v-radio value="otraCantidad" label="Otra cantidad">
            </v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="12" class="pt-0 pb-0 mt-0 mb-0">
          <v-row align="center" justify="center">
            <v-col cols="6" class="pt-0 pb-0 mt-0 mb-0">
              <v-currency-field :label="labelCantidad" :hint="minimoPagar" :persistent-hint="editar" :readonly="!editar" :outlined="editar" v-bind="currency_config" :error-messages="errors.price" v-model="cantidadPago2"></v-currency-field>
            </v-col>
            <v-col cols="6" class="pt-0 pb-0 mt-0 mb-0">
              <v-row align="center" justify="center">
                <v-col cols="12" class="pt-0 pb-0 mt-0 mb-0">
                  <span class="caption font-weight-medium">Esta es una operación segura respaldada por:</span>
                </v-col>
                <v-col cols="10" class="pt-0 pb-0 mt-0 mb-0">
                  <v-img src="@/assets/OXXO_PAY.jpg" aspect-ratio="3" contain></v-img>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-text-field :rules="[rules.required]" class="pt-0 mt-0" label="*Nombre en la tarjeta" v-model="card.card.name" outlined data-conekta="card[name]" v-on:input="card.card.name = card.card.name.toUpperCase()"></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field :rules="[rules.required, rules.min]" label="*Número de tarjeta" v-mask="mask" v-model="card.card.number" outlined data-conekta="card[number]"></v-text-field>
        </v-col>
        <v-col cols="4">
          <v-select :rules="[rules.required]" :items="meses" label="*Mes de vencimiento" v-model="card.card.exp_month" outlined data-conekta="card[exp_month]"></v-select>
        </v-col>
        <v-col cols="4">
          <v-select :rules="[rules.required]" :items="annos" label="*Año de vencimiento" v-model="card.card.exp_year" outlined data-conekta="card[exp_year]"></v-select>
        </v-col>
        <v-col cols="4">
          <v-text-field :rules="[rules.required]" label="*CVV" v-model="card.card.csv" outlined data-conekta="card[cvc]" type="number" onkeydown="javascript: return event.keyCode == 69 ? false : true"></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field :rules="emailRules" label="*Correo electrónico" v-model="card.card.correo" outlined></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field :rules="[rules.required, rules.minTel]" label="*Número de telefono" v-mask="maskTel" v-model="card.card.telefono" outlined></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-row align="end" justify="end">
              <v-btn color="red" class="white--text mr-3" @click="cancelarPago">Cancelar</v-btn>
              <v-btn :disabled="!valid" type="submit" color="#008230" class="white--text ml-3" @click="realizarPago(cantidadPago2)">Pagar</v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { mask } from 'vue-the-mask';
import { EventBus } from '@/components/EventBus.js';

export default {
  name: "PagoTarjeta",
  directives: {
    mask,
  },
  watch: {
    cantidadPago(val){
      console.log(val);
      if(val == "otraCantidad"){
        this.editar = true;
        this.labelCantidad = "Inserte la cantidad a pagar";
      }else{
        this.editar=false;
        this.cantidadPago2 = val;
        this.labelCantidad = "Cantidad a pagar";
      }
    }
  },
  computed: {
    ...mapState(["cuenta", "dialogPagoTarjeta", "datosPagoTarjeta", "card"])
  },
  methods: {
    ...mapActions(["realizarPago"]),
    cancelarPago() {
      //this.$refs.form.reset()
      //this.cantidadPago = 0;    
      //this.cantidadPago2 = 0;
      //this.$refs.form.resetValidation();
      this.$store.commit("setVisiblePagoTarjeta", false);
    },

    submit: e => {
      e.preventDefault();
    },
  },
  data() {
    return {
      meses: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
      annos: [],
      editar: false,
      cantidadPago: 0,
      cantidadPago2: 0,
      mask: '####-####-####-####',
      maskTel: '(###) ###-####',
      labelCantidad: '',
      minimoPagar: '',
      valid: false,
      rules: {
        required: value => !!value || 'Requerido.',
        min: v => v.length >= 19 || 'Se requieren 16 dígitos',
        minTel: v => v.length >= 14 || 'Se requieren 10 dígitos',
      },
      emailRules: [
        v => !!v || 'Requerido',
        v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Correo electrónico debe ser valido',
      ],
      currency_config: {
          decimal: '.',
          thousands: ',',
          prefix: '$ ',
          precision: 2,
          masked: false,
          allowBlank: false
      },
      errors: {},
    };
  },
  updated() {
    EventBus.$on('validaciones', nombre => {
      this.$refs.form.reset();
      this.cantidadPago = 0;    
      this.cantidadPago2 = 0;
      this.$refs.form.resetValidation();
      console.log("actualizavalidacion")
    });
  },
  beforeMount() {
    console.log("deberia borrar2");
    this.minimoPagar = "minimo a pagar: " + Number(this.$store.state.datosPagoTarjeta.pagoDescuento * .50).toFixed(2);
    var f = new Date();
    var actual = f.getFullYear();
    for (var i = actual; i < actual + 15; i++) {
      this.annos.push(""+i);
    }
  }
};

/*
-nombre en el header, boton de logout en header

:disabled="!valid"
*/
</script>

<style scoped>
.centrarBody {
  padding-left: 10%;
  padding-right: 10%;
}
</style>